import {useEffect, useState} from 'react'
import {useLocation, useNavigate} from 'react-router-dom'
import {useContextType} from '../../../../../app/services/useContextType'

const GetAssetName = () => {
  const location = useLocation()
  const path = location.pathname
  const navigate = useNavigate()
  const contextType = useContextType()
  const [assetName, setAssetName] = useState<string | null>(null)

  useEffect(() => {
    if (path.includes('/frequencies') && !path.includes('/inspections')) {
      const name = localStorage.getItem('assetName')
      setAssetName(name)
      if (!name) {
        navigate(contextType === 'site' ? '/sites' : '/assets')
      }
    }
  }, [path, navigate])

  if (path.includes('/frequencies') && !path.includes('/inspections') && assetName) {
    return <span className='ms-2'> ({assetName})</span>
  }

  return null
}

export default GetAssetName
